import React, { ReactNode, Fragment } from "react"
import { LoadingErrorState } from "../types"

type Props = {
  errorState: LoadingErrorState
  isLoading: boolean
  children: ReactNode
  loadingSkeleton: ReactNode
  errorStateComponent: ReactNode
}

function LoadingStateWrapper(props: Props) {
  return (
    <Fragment>
      {(props.errorState === null && (
        <Fragment>
          {(props.isLoading && (
            <Fragment>{props.loadingSkeleton}</Fragment>
          )) || <Fragment>{props.children}</Fragment>}
        </Fragment>
      )) || <Fragment>{props.errorStateComponent}</Fragment>}
    </Fragment>
  )
}

export default LoadingStateWrapper
